
import { validate } from './validations';
import { build } from '../../../services/crudFactory';
import { Action } from '../../../services/actions.factory';
import Api from '../../../services/api.service';

const BASE_PATH = '/lognex/cargo-shipment';
const prefix = 'crudCargoShipment';


const crud = build(validate, BASE_PATH);

const newTypes = {
    LOOKUP_CARRIER_SET_VISIBLE: `${prefix}setLookupCarrierVisible`,
    LOOKUP_VEHICLE_SET_VISIBLE: `${prefix}setLookupVehicleVisible`,
    LOOKUP_VEHICLE_TYPE_SET_VISIBLE: `${prefix}setLookupVehicleTypeVisible`,
    SET_SELECTED_ORDERS: `${prefix}setSelectedOrders`,
    REMOVE_SELECTED_ORDERS: `${prefix}removeSelectedOrders`,
    LOOKUP_ORDER_SET_VISIBLE: `${prefix}setLookupOrderVisible`,
    LOOKUP_ORDER_SET_INDEX: `${prefix}setLookupOrderIndex`,
    LOOKUP_ORDER_SET_MAX: `${prefix}setLookupOrderMax`,
    LOOKUP_ORDER_SET_COUNT: `${prefix}setLookupOrderCount`,
    LOOKUP_ORDER_SET_SORT_FIELD: `${prefix}setLookupOrderSortField`,
    LOOKUP_ORDER_SET_SORT_ORDER: `${prefix}setLookupOrderSortOrder`,
    LOOKUP_ORDER_PAGINATE: `${prefix}lookupOrderPaginate`,
    SET_ORDER_FILTERS: `${prefix}setOrderFilters`,
    SET_ORDERS: `${prefix}setOrders`,
    ADD_ORDERS: `${prefix}addOrders`,
    FETCH_ORDERS: `${prefix}fetchOrders`,
    SET_CARD_VALUES: `${prefix}calcCards`,
    SET_CARGO_SHIPMENT: `${prefix}setCargoShipment`,
    SET_FREIGHT_COMBINED_SHIPMENT: `${prefix}setFreightCombinedShipment`,
    CALCULATE_CARGO_SHIPMENT_WITH_FREIGHT_COMBINED_ORDER: `${prefix}calculateCargoShipmentWithFreightCombinedOrder`,
    SET_FREIGHT_COMBINED_ORDER: `${prefix}setFreightCombinedOrder`,
    CALC_FREIGHT_COMBINED_ORDERS: `${prefix}calcFreightCombinedOrders`,
    SET_FREIGHT_TOTAL_VALUE: `${prefix}setFreightTotalValue`,
    SET_FREIGHT_COMBINED_CHECK: `${prefix}setFreightCombinedCheck`,
}

const actions = new Action(prefix, crud);

const types = Object.assign({}, actions.types, newTypes);


actions.loadQuotes = (quotes) => {
    return {
        type: types.LOAD_QUOTES,
        quotes
    }
}
actions.lookupCarrierSetVisible = (visible) => {
    return {
        type: types.LOOKUP_CARRIER_SET_VISIBLE,
        visible
    }
}
actions.lookupVehicleSetVisible = (visible) => {
    return {
        type: types.LOOKUP_VEHICLE_SET_VISIBLE,
        visible
    }
}
actions.lookupVehicleTypeSetVisible = (visible) => {
    return {
        type: types.LOOKUP_VEHICLE_TYPE_SET_VISIBLE,
        visible
    }
}
actions.setSelectedOrders = (orders) => {
    return {
        type: types.SET_SELECTED_ORDERS,
        orders
    }
}

actions.removeSelectedOrders = () => {
    return {
        type: types.REMOVE_SELECTED_ORDERS,
    }
}

actions.setLookupOrderVisible = (visible) => {
    return {
        type: types.LOOKUP_ORDER_SET_VISIBLE,
        visible
    }
}

actions.setLookupOrderIndex = (index) => {
    return {
        type: types.LOOKUP_ORDER_SET_INDEX,
        index
    }
}

actions.setLookupOrderMax = (max) => {
    return {
        type: types.LOOKUP_ORDER_SET_MAX,
        max
    }
}
actions.setLookupOrderCount = (count) => {
    return {
        type: types.LOOKUP_ORDER_SET_COUNT,
        count
    }
}
actions.setLookupOrderSortField = (sortField) => {
    return {
        type: types.LOOKUP_ORDER_SET_SORT_FIELD,
        sortField
    }
}
actions.setLookupOrderSortOrder = (sortOrder) => {
    return {
        type: types.LOOKUP_ORDER_SET_SORT_ORDER,
        sortOrder
    }
}

actions.lookupOrderPaginate = (params) => {
    return {
        type: types.LOOKUP_ORDER_PAGINATE,
        params
    }
}

actions.setOrderFilters = (filters) => {
    return {
        type: types.SET_ORDER_FILTERS,
        filters
    }
}
actions.setOrders = (orders) => {
    return {
        type: types.SET_ORDERS,
        async: false,
        orders
    }
}
actions.addOrders = (orders) => {
    return {
        type: types.ADD_ORDERS,
        orders
    }
}

actions.fetchOrders = () => {
    return {
        type: types.FETCH_ORDERS,
        async: true
    }
}

actions.setCargoShipment = (cargoShipment) => {
    return {
        type: types.SET_CARGO_SHIPMENT,
        cargoShipment
    }
}

actions.setFreightCombinedCheck = (freightCombinedCheck) => {
    return {
        type: types.SET_FREIGHT_COMBINED_CHECK,
        freightCombinedCheck
    }

}

actions.setFreightCombinedShipment = (freightCombinedShipment) => {
    return {
        type: types.SET_FREIGHT_COMBINED_SHIPMENT,
        freightCombinedShipment
    }

}
actions.calculateCargoShipmentWithFreightCombinedOrder = (freightCombinedOrder,orderCode) => {
    return {
        type: types.CALCULATE_CARGO_SHIPMENT_WITH_FREIGHT_COMBINED_ORDER,
        freightCombinedOrder,
        orderCode
    }

}
actions.setFreightCombinedOrder = (freightCombinedOrder,orderCode) => {
    return {
        type: types.SET_FREIGHT_COMBINED_ORDER,
        freightCombinedOrder,
        orderCode
    }

}
actions.setCalcFreightCombinedOrdersWithShipmentFreight = (freightCombinedShipment) => {
    return {
        type: types.CALC_FREIGHT_COMBINED_ORDERS,
        freightCombinedShipment
    }

}
actions.setFreightTotaValue = () => {
    return {
        type: types.SET_FREIGHT_TOTAL_VALUE,
    }
}

actions.loadOrders = () => {
    return (dispatch, getState) => {
        const state = getState().crudCargoShipmentState;
        const orderFilters = state.orderFilters || []
        let sortFields = [];

        let localFilters = [
            {
                campo: 'scriptStatus',
                valor: "NOT_SCRIPTED",
                tipoFiltro: 'IGUAL_A'
            },
        ]
        const filters = [...orderFilters, ...localFilters];


        const params = {
            filters,
            index: state.lookupOrder.index || 0,
            max: state.lookupOrder.max || 100,
            // permissions: null,
            // _filters: filters,
            // get filters() {
            //     return this._filters;
            // },
            // set filters(value) {
            //     this._filters = value;
            // },
            // sortFields
        };
        dispatch(actions.fetchOrders());
        Api.post('/api/v1/lognex/shipment-order/all', params)
            .then((response) => {
                const data = response.data || {};
                dispatch(actions.setLookupOrderIndex(data.index ));
                dispatch(actions.setLookupOrderMax(data.size));
                dispatch(actions.setLookupOrderCount(data.count));
                dispatch(actions.setOrders(data.records || []));
            })
            .catch((error) => {
                dispatch(actions.setOrders([]))
            })
    }
}

actions.calcCards = () => {
    return {
        type: types.SET_CARD_VALUES,
    }
}


actions.loadCargoShipmentById = (oid) => {
    return (dispatch, getState) => {
        Api.post(`/api/v1/lognex/cargo-shipment/${oid}`)
            .then((response) => {
                const data = response.data || {}; 
                dispatch(actions.setCargoShipment(data))
                dispatch(actions.calcCards());
            })
            .catch((error) => {
                console.log(error)
                dispatch(actions.setOrders([]))
                dispatch(actions.calcCards());
            })
    }
}



export { types, actions }